/** Content (A08/A11 epics): deliverables via /v1/deliverables; the asset library is /content/assets. */
import { Link } from 'react-router';
import { Badge } from '@qm/ui';
import { useApp } from '../../../lib/app-context';
import { useFormat } from '../../../lib/format';
import { ListScreen, str } from '../_shared/ListScreen';

export function ContentPage() {
  const { t } = useApp();
  const f = useFormat();
  return (
    <ListScreen titleKey="shell.screens.content.title" introKey="shell.screens.content.intro" path="/v1/deliverables" emptyKey="shell.screens.content.empty" emptyAction={{ to: '/calendar', labelKey: 'shell.empty.calendar' }}
      actions={<Link to="/content/assets">{t('deliverables.assets.title')}</Link>}
      columns={[
        { key: 'title', header: t('shell.col.title'), render: (r) => <bdi>{f.text(r.title)}</bdi> },
        { key: 'kind', header: t('shell.col.type'), render: (r) => str(r.kind ?? r.type) },
        { key: 'status', header: t('shell.col.status'), render: (r) => <Badge>{str(r.status)}</Badge> },
        { key: 'dueAt', header: t('shell.col.due'), render: (r) => f.date(str(r.dueAt ?? r.due_at)) },
      ]} />
  );
}
